//= ../../../node_modules/jquery/dist/jquery.js
//= ../../../node_modules/svg4everybody/dist/svg4everybody.js
//= ../../../node_modules/queryloader2/queryloader2.min.js
// //= ../../../node_modules/lazyload/lazyload.min.js // need es2015
//= ../../../node_modules/popper.js/dist/umd/popper.min.js
//= ../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js
// //= ../../../node_modules/bootstrap/dist/js/bootstrap.js
//= ../../../node_modules/jquery.easing/jquery.easing.js
//= ../../../node_modules/jquery.cookie/jquery.cookie.js
//= ../../../node_modules/jquery-sticky/jquery.sticky.js
//= ../../../node_modules/inputmask/dist/min/jquery.inputmask.bundle.min.js
//= ../../../node_modules/slick-lightbox/dist/slick-lightbox.min.js
//= ../../../node_modules/slick-carousel/slick/slick.min.js
//= ../../../node_modules/selectize/dist/js/standalone/selectize.min.js
//= ../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js
//= ../../../node_modules/jquery-timepicker/jquery.timepicker.js
//= ../../../node_modules/jquery.smartbanner/jquery.smartbanner.js

//= plugins/affix.js
//= plugins/validation.js
//= plugins/mobile-os.js
//= plugins/snowflakes.js
//= plugins/jquery-spincrement/jquery.spincrement.min.js
